module.exports = __webpack_public_path__ + "img/horizontal_3_5_4.559f0e07.png";